/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { advancedRoadmapsScenarioIdResource } from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { legacyPlanPageRedirectRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/legacyPlanPageRedirectRoute.tsx';
import { RedirectLegacyPlanPage } from './common/ui/redirect/plan/RedirectPlanPageWithoutScenarioIdPreloadQuery.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const legacyPlanPageRedirectRouteEntry: Route = createEntry(
	legacyPlanPageRedirectRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectLegacyPlanPage,
		isRedirect: true,
		layout: globalLayout,
		resources: [...getNavigationResources(), advancedRoadmapsScenarioIdResource],

		navigation: {
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
